import React, { useEffect, useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import { allNotificationsRead, useGetNotificationsQuery, useUpdateNotificationsAsReadMutation } from 'context/notification/notificationsApiSlice';
import { formatDistanceToNow, parseISO } from 'date-fns';
import frLocale from 'date-fns/locale/fr';

// @mui material components
import { List, ListItem, ListItemText, ListItemAvatar, Badge, Icon, Tooltip, IconButton, Divider } from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDAvatar from "dashboard/components/MDAvatar";
import MDAlert from "dashboard/components/MDAlert";
import loader from "assets/images/shapes/loader.svg";

import useSearch from "hooks/useSearch";

function Notifications({ unreadNotifs, unReadNotificationsNum, showAlerts, iconsStyle, toggleDrawer }) {
  const { searchTerm, filterSearch } = useSearch(); // filterSearch
  const [updateNotificationsAsRead] = useUpdateNotificationsAsReadMutation();
  let pageCount = 0;
  let notificationList=[];
  let totalResult = 0;

  const dispatch = useDispatch();
  const notificationsQuery = useMemo(
    () => ({
      page: searchTerm.page,
      filters: JSON.stringify({name : searchTerm.text, type : "alert"}),
      notificationsPerpage: 12,
     }),
    [searchTerm]
  );

  const { data : notifis =[], isSuccess, isLoading, isError, Error } = useGetNotificationsQuery(notificationsQuery,{
    refetchOnMountOrArgChange :true
  });

  const getNotifications = notifisDetails => {
    filterSearch(notifisDetails)
  }
  
  if (isSuccess) {
    const {notificationsDetails, entities } = notifis;
    notificationList = Object.values(entities).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    pageCount = Number(Math.ceil(notificationsDetails?.total_results / notificationsDetails?.notificationsPerpage ));
    totalResult = notificationsDetails?.total_results
  }

  // Mark all notifications as read when the component mounts
  useEffect(() => {
    return ()=>{
      if(unReadNotificationsNum === 0 ) return;
      dispatch(allNotificationsRead(unreadNotifs));
      updateNotificationsAsRead(JSON.stringify(unreadNotifs.map(item=>item.id)));
    }
  }, []);

  useEffect(() => {
    /* eslint-disable */
    isError ? showAlerts({
      title : "Dashboard Alert",
      type  : "toast",
      msg :  Error?.error || Error?.message,
      color :"error"
    }) : null
  }, [isError,Error]);

  const onDelete =  id => {
    showAlerts({code:"warning", icon:"warning", title : "Supprimer une notification",msg : "Êtes-vous sûr de vouloir supprimer cette notification ?  ", type : "confirm", action: {id}});
  }

  return (
      <MDBox >
        <MDTypography variant="h5" my={2} color="text">Notifications</MDTypography>
        <IconButton 
          onClick={toggleDrawer(false)} 
          size="small"
          disableRipple
          sx={{position:"absolute", top : 5, right : 5}}
          variant="contained"
          >
            <Icon sx={iconsStyle}>cancel</Icon>
          </IconButton>
        <Divider sx={{my:1}}/>
        <List sx={{ width: '100%' }}>
        {isLoading && <MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,top: "50%",left: "50%",transform: "translate3d(-24px, -20px, 0)"}}  
                    src={loader} alt="Avatar" variant="square" size="md" />}
          {isSuccess && notificationList.map((notification) => (
            <React.Fragment key={notification.id}>
            <ListItem  alignItems="center"
              sx={{
                p:1,
                backgroundColor :  ({ palette: { background, grey, mode } }) => notification.seen || notification.seen === 1  ? background.card : grey[mode === 'light' ? 300 : 700]
              }}
            >
            <ListItemAvatar>
              <Badge sx={{
                "& .MuiBadge-badge" : {
                  background:  ({ palette: { gradients }, functions: { linearGradient } }) => 
                    linearGradient(gradients[notification.color].main, gradients[notification.color].state),
                    height:28,
                    width :28,
                    borderRadius : "50%"
                  },
                "& .MuiIcon-root" :{
                 
                  fontSize : "18px !important"
                }
                }} 
                overlap="circular" anchorOrigin={{vertical: 'bottom',horizontal: 'right'}} size="large" badgeContent={<Icon  sx={{color : notification.color === "light" ? "#54586F" : "white !important"}}>{notification.icon}</Icon>} color={notification.color}>
                <MDAvatar alt={notification.displayName} src={`${process.env.REACT_APP_PUBLIC_URL}/assets/img/profile/${notification.photoURL}`} />
              </Badge>
            </ListItemAvatar>
            <ListItemText 
              sx={{ textWrap:"wrap", "& .MuiTypography-body1":{lineHeight : 1 },"& .MuiTypography-body2" :{ lineHeight :.6, fontWeight: !notification.seen  ? 700 : "normal" },  px : 1}}
              primary={<><MDTypography
                sx={{ display: 'inline', fontSize:14, fontWeight :600 }}
                component="span"
                color="secondary"
                >{notification.displayName}</MDTypography>
                <MDTypography
                sx={{ display: 'inline', fontSize:14 }}
                component="span"
                variant="body2"
                color="text"
                >{notification.content}</MDTypography>
                <Tooltip title="Delete notification" placement="top" arrow>
                    <IconButton size="small" disableRipple sx={{ p:.5, float:"right","& .material-icons-round":{fontSize:"1rem !important"}}} onClick={()=>onDelete(notification.id)}><Icon sx={{fontSize:"1rem !important"}}>delete</Icon></IconButton>
                  </Tooltip>
                </>}
              secondary={<MDTypography
                    sx={{ display: 'inline'}}
                    component="span"
                    variant="caption"
                    color="dark"
                    fontWeight="medium"
                  >
                    {formatDistanceToNow(parseISO(notification.createdAt),{locale: frLocale})}
                  </MDTypography>}
            />
          </ListItem>
          <Divider sx={{my:.1}}/>
          </React.Fragment>
          ))}
        </List> 
        {notificationList.length === 0 && <MDAlert mt={2} color="light"><small style={{ fontSize:"14px",whiteSpace: "normal" }}> Aucune notification pour l&apos;instant </small></MDAlert>}
      </MDBox>
  );
}

export default Notifications;

